import { Component, OnInit } from '@angular/core';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { ClientDataService } from '../../data-services/client.service';
import { SelectItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { PatientAddComponent } from '../patient/patient.add';
import { ClientEditComponent } from '../client/client.edit';
import { ProviderAddComponent } from '../../modules/provider/provider.add';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ListboxModule } from 'primeng/listbox';
import { DatePickerModule } from 'primeng/datepicker';
import { PopoverModule } from 'primeng/popover';
import { FieldsetModule } from 'primeng/fieldset';
import { RouterModule } from '@angular/router';

@Component({
   selector: 'app-requisition-add',
   templateUrl: './requisition.add.html',
   providers: [DialogService],
   imports: [FormsModule, SelectModule, ListboxModule, DatePickerModule, PopoverModule, FieldsetModule, RouterModule]
})
export class RequisitionAddComponent implements OnInit {

   constructor(private requisitionDataService: RequisitionDataService,
      private clientDataService: ClientDataService,
      public dialogService: DialogService) {
   }

   requisition;
   loading: boolean;
   genders: SelectItem[];
   ethnicities: SelectItem[];
   states: SelectItem[];
   providers: SelectItem[];
   testnames: SelectItem[];
   specimentypes: SelectItem[];
   collectors: SelectItem[];
   dxcodes: SelectItem[];

   ngOnInit() {
      this.loading = true;

      this.genders = [
         { label: '', value: '' },
         { label: 'Male', value: 'M' },
         { label: 'Female', value: 'F' },
         { label: 'Undecided', value: 'U' }
      ];

      this.ethnicities = [
         { label: '', value: '' },
         { label: 'White', value: 'W' },
         { label: 'Brown', value: 'R' },
         { label: 'Black', value: 'B' },
         { label: 'Polka Dotted', value: 'P' }
      ];

      this.states = [
         { label: '', value: '' },
         { label: 'AK', value: 'AK' },
         { label: 'AL', value: 'AL' },
         { label: 'AR', value: 'AR' },
         { label: 'CA', value: 'CA' }
      ];

      this.providers = [
         { label: '', value: '' },
         { label: '012345 - Provider 1', value: 'AK' },
         { label: '234523 - Provider 2', value: 'AL' },
         { label: '523423 - Provider 3', value: 'AR' },
         { label: '564568 - Provider 4', value: 'CA' }
      ];

      this.testnames = [
         { label: '', value: '' },
         { label: 'Test 1', value: 'AK' },
         { label: 'Test 2', value: 'AL' },
         { label: 'Test 3', value: 'AR' },
         { label: 'Test 4', value: 'CA' }
      ];

      this.specimentypes = [
         { label: '', value: '' },
         { label: 'Specimen Type 1', value: 'AK' },
         { label: 'Specimen Type 2', value: 'AL' },
         { label: 'Specimen Type 3', value: 'AR' },
         { label: 'Specimen Type 4', value: 'CA' }
      ];

      this.collectors = [
         { label: '', value: '' },
         { label: 'Collector 1', value: 'AK' },
         { label: 'Collector 2', value: 'AL' },
         { label: 'Collector 3', value: 'AR' },
         { label: 'Collector 4', value: 'CA' }
      ];

      this.dxcodes = [
         { label: 'A123 - Description of dx code A123', value: 'A123' },
         { label: 'B234 - Description of dx code B234', value: 'B234' },
         { label: 'C345 - Description of dx code C345', value: 'C345' }
      ];

      this.requisitionDataService.getEmptyModel().subscribe((data: any) => {
         this.requisition = data;
         this.requisition.Patient = {
            HomeAddress: {},
            WorkAddress: {}
         };
         this.loading = false;
      });
   }

   openPatientEdit() {
      var patientid;
      if (this.requisition && this.requisition.patient) {
         patientid = this.requisition.Patient.Id;
      }
      else {
         patientid = 0;
      }

      const ref = this.dialogService.open(PatientAddComponent, {
         header: 'Edit Patient',
         data: {
            id: patientid,
            patient: this.requisition.Patient
         },
         width: '700px'
      });

      ref.onClose.subscribe((patient: any) => {
         if (patient) {
            this.requisition.Patient = patient;
         }
      });
   }

   openClientEdit() {
      const ref = this.dialogService.open(ClientEditComponent, {
         header: 'Edit Client',
         width: '700px'
      });
   }

   clients: any[] = [];
   client: any = {};
   clientSearchString: string;
   public doClientSearch() {
      if (this.clientSearchString != null && this.clientSearchString.length > 0) {
         this.clientDataService.searchList(this.clientSearchString).subscribe((data: any) => {
            this.clients = [];
            for (var i = 0; i < data.length; i++) {
               this.clients.push(data[i]);
            }
         });
      }
   }

   public selectClient(clientsearch, i) {
      this.client = this.clients[i];

      this.providers = this.client.Providers.map(p => ({
         label: p.ProviderName,
         value: p.ProviderNPI
      }));

      clientsearch.hide();
   }

   providerNPI;
   public addProvider() {
      const ref = this.dialogService.open(ProviderAddComponent, {
         header: 'Find a provider to add',
         width: '750px',
         height: '500px'
      });

      ref.onClose.subscribe((provider: any) => {
         if (provider) {
            this.client.Providers.push(provider);
            this.providers.push({
               label: provider.ProviderName,
               value: provider.ProviderNPI
            });
            this.providerNPI = provider.ProviderNPI;
            this.requisition.Provider = provider;
         }
      });
   }
}
